import { supportChat as base } from './base';
import { supportChat as AT } from './AT';
import { supportChat as CZ } from './CZ';
import { supportChat as HR } from './HR';
import { supportChat as HU } from './HU';
import { supportChat as RO } from './RO';
import { supportChat as SK } from './SK';

export const supportChatFeatureConfigMap = {
    base,
    AT,
    CZ,
    HR,
    HU,
    RO,
    SK,
};
